import { Globals } from "../CoreApp/Globals";

export function handleBookAdvance(wsMgr) {
  Globals._publishRef.PreFlightPDF(wsMgr);
}
